export default {
	cihangban: 'This flight',
	paifangliang: 'Emissions are calculated for 1 passenger in your selected seating class',
	chengke: 'Passenger',
	quebaoziliaozhengque: 'Please Ensure That All The Information Is Correct',
	ruhetianxiechengke: "How to fill in traveler's details?",
	beizhu: 'Remarks',
	piaohao: 'Ticket No.',
	chakanpiaojiaguize: 'View Fare Rules',
	shengyushijian: 'X minutes remaining to complete this booking.',
	zongjie: 'Summary',
	shuifeifujia: 'Taxes & Surchages',
	zonge: 'Total',
	xingbie: 'Gender',
	nan: 'Male',
	nv: 'Female',
	xingshi: 'Family / Last Name',
	zhongjianming: 'Middle Name',
	mingzi: 'Given/First & Middle Name',
	lizi0: 'EXAMPLE:LEE',
	ruyou: 'IF ANY',
	lizi: 'EXAMPLE:SIU MENG',
	zhengjianleixing: 'Document Type',
	qingxuanze: 'Please Select',
	huzhaohaoma: ' Passport Number',
	huzhao: 'Passport',
	qingshuru: 'Please Enter ',
	huzhaoguojia: 'Document Country Region',
	daoqiriqi: 'Passport Expiry Date',
	chushengriqi: 'Date of Birth',
	shifouchangke: 'Add Frequent Flyer Program Number?',
	lianluoren: 'Contact Person Information',
	dianyoudizhi: ' Email Address',
	zhengquedianyoudizhi: ' Correct Email Address',
	lianluodianhua: ' Telephone Number',
	qingshurudianhua: 'Mobile Phone',
	guojia: 'Country',
	wanchengyuding: 'Complete Your Booking',
	wancheng: 'Done',
	fukuanxijie: 'Payment Details',
	shuikuanfujiafei: 'Includes Taxes & Surcharges',
	woyiyueduotiaokuan: 'I have read and agreed to the Terms and Conditions.',
	woyiyueduo: 'I have read and agreed to the',
	baocunxiangxixinxi: 'Save details here to auto-complete form for future flight booking.',
	xiayibu: 'Next',
	fanhui: 'Back',
	baocun: 'Save',
	xuanzezuowei: 'please select a seat',
	ewaituibu: 'Extra legroom',
	shouxuan: 'Preferred',
	biaozhun: 'Standard',
	queren: 'Confirm',
	chongzhi: 'Reset',
	quxiao: 'Cancel',
	yixuan: 'Occupied',
	shangwu: 'Business',
	jingji: 'Economy',
	meiyouxuanwei: 'No Seat Selected',
	xuanzezhong: 'selected',
	xiagehangban: 'Next Flight',
	chuangjiandingdan: 'Book Now',
	chengkeanzhengjian:
		'All Title(s) and Passenger name(s) must be entered exactly as shown on your passport(s) or other valid travel document(s). No amendments on Title(s) or Passenger name(s) are allowed once the transaction is completed successfully.',
	shurudianziyoujian: 'To Receive Reservation Confirmation & Ticketing Receipt.',
	hangbanbiangengshouyueshu:
		'Selected flights subject to schedule change and is bound by airlines concerned Terms & Conditions.',
	yudingzhongguanli:
		'You can still change* and/or manage your reservation in “My Booking”. However, please note that any amendments to a Confirmed Booking will attract a change fee, over and above payments chargeable for pre-existing or new purchases made.',
	cuxiaopiaojiabu: `- No Changes may be permitted for Promotional fares.`,
	chakanlvxingjianyi:
		'- Please check the Travel Advice and Terms & Conditions of Carriage in your Travel Itinerary for permissible changes.'
};
